import * as React from "react";
import { useTranslation } from "react-i18next";
import { Alert } from "components/bootstrap";
const NoEntitiesExist = ({ children = void 0 }) => {
  const { t } = useTranslation("common");
  return /* @__PURE__ */ React.createElement(Alert, { className: "no-bm" }, children != null ? children : t("empty.no_entities"));
};
export default NoEntitiesExist;
